module.exports = __webpack_public_path__ + "static/media/option-1.72e8ad48.ogg";